<template>
  <div :class="`stepper ${className || ''}`">
    <v-progress-linear height="2" color="success" :value="progress"> </v-progress-linear>
    <v-row class="stepper_row">
      <template v-for="(item, index) in texts">
        <v-col
          cols="12"
          :md="md"
          col
          v-if="!$vuetify.breakpoint.xsOnly || index === step - 1"
          :key="item"
          class="stepper_step"
        >
          <div
            :class="{
              stepper_step_text: true,
              stepper_step_text_stepped: index === step - 1,
              stepper_step_text_border: index === 1,
            }"
          >
            {{ index | keyFilter }}. {{ item }}
          </div>
        </v-col>
      </template>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "Stepper",
  props: {
    step: Number,
    texts: Object,
    className: String,
  },
  computed: {
    progress() {
      return (this.step * 100) / Object.keys(this.texts).length;
    },
    md() {
      return 12 / Object.keys(this.texts).length;
    },
  },
  filters: {
    keyFilter(val) {
      if (val) {
        return val.replace("_", "");
      }
    },
  },
};
</script>
<style lang="scss">
.stepper {
  border-bottom: 1px solid $primarylight2;
  height: 67px;

  &_row {
    height: 100%;
  }
  &_step {
    display: flex;
    align-items: center;

    &_text {
      width: 100%;
      font-style: normal;
      font-weight: 500;
      font-size: 1rem;
      line-height: 17px;
      color: $primarylight3;
      text-align: center;

      &_stepped {
        color: $success;
      }

      &_border {
        border-left: 1px solid rgba(15, 15, 15, 0.1);
        border-right: 1px solid rgba(15, 15, 15, 0.1);
      }
    }
  }
}
</style>
